import { useCurrentBot } from '~hooks/useCurrentBot';
import { useUserId } from '~hooks/useUserId';
import { useGetTopicsQuery } from '~services/api/topics';
import type { TTopic } from '~services/api/topics/types';

export const useTopics = (botId: string): TTopic[] => {
	const userId = useUserId();
	const { bot } = useCurrentBot({ recipientId: botId });
	const { data = [] } = useGetTopicsQuery(
		{ userId, botId },
		{ skip: !bot.clientId }
	);
	return data;
};
